// Set this week's single focus goal, and review the completed-goals archive.
import { createWeeklyGoal, loadCompletedGoals } from '../lib/grit-data.js';
import { currentWeekStart } from '../lib/weekly-goal.js';
import { toast } from './toast.js';

let overlay = null;
function close() { if (overlay) { overlay.remove(); overlay = null; } }
const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

export function openWeeklyGoalSheet(onSaved) {
  close();
  overlay = document.createElement('div');
  overlay.className = 'fixed inset-0 z-[120] flex items-end justify-center bg-black/30';
  overlay.innerHTML = `
    <div class="grit-sheet">
      <div class="grit-sheet-handle"></div>
      <div class="text-[17px] font-bold text-ink">This week's one focus</div>
      <div class="text-[13px] text-inksoft mb-4">One goal. Finish it before you add another.</div>
      <label class="text-[12px] font-bold text-inksoft">The goal</label>
      <input id="wg-text" placeholder="e.g. Hit 100g protein" class="grit-input w-full py-2.5 mt-1 mb-3 font-bold" />
      <div class="grid grid-cols-2 gap-3 mb-3">
        <div>
          <label class="text-[12px] font-bold text-inksoft">How many days</label>
          <input id="wg-days" type="number" inputmode="numeric" value="5" min="1" max="7" class="grit-input w-full py-2.5 mt-1 text-center font-bold" />
        </div>
        <div>
          <label class="text-[12px] font-bold text-inksoft">Reward</label>
          <input id="wg-reward" placeholder="e.g. new shoes" class="grit-input w-full py-2.5 mt-1 font-bold" />
        </div>
      </div>
      <button id="wg-save" class="grit-btn">Lock it in</button>
      <button id="wg-cancel" class="w-full text-inksoft font-bold py-3 mt-1">Cancel</button>
    </div>`;
  overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
  overlay.querySelector('#wg-cancel').onclick = close;
  overlay.querySelector('#wg-save').onclick = async () => {
    const text = overlay.querySelector('#wg-text').value.trim();
    const days = Math.max(1, Math.min(7, Number(overlay.querySelector('#wg-days').value) || 5));
    const reward = overlay.querySelector('#wg-reward').value.trim();
    if (!text) { toast('Type your goal first', { tone: 'bad' }); return; }
    const g = await createWeeklyGoal({ text, target_days: days, reward, week_start: currentWeekStart() });
    if (!g) { toast("Couldn't save, try again", { tone: 'bad' }); return; }
    toast('Focus locked'); close(); if (onSaved) onSaved();
  };
  document.body.appendChild(overlay);
}

export async function openCompletedGoals() {
  close();
  const goals = await loadCompletedGoals();
  const rows = goals.map((g) => `
    <div class="grit-card p-3 mb-2 flex items-center justify-between gap-3">
      <div class="min-w-0">
        <div class="font-bold text-[15px] text-ink truncate">${esc(g.text)}</div>
        <div class="text-[12px] text-inksoft">${g.status === 'completed' ? 'Completed' : 'Dropped'}${g.reward ? ' · 🎁 ' + esc(g.reward) : ''}</div>
      </div>
      ${g.status === 'completed' ? '<span class="grit-chip-success flex-none">Done</span>' : '<span class="grit-chip bg-fill text-ink flex-none">Dropped</span>'}
    </div>`).join('') || '<p class="text-inksoft text-[15px] py-4 text-center">No finished goals yet. Your first win shows up here.</p>';
  overlay = document.createElement('div');
  overlay.className = 'fixed inset-0 z-[120] flex items-end justify-center bg-black/30';
  overlay.innerHTML = `
    <div class="grit-sheet overflow-auto">
      <div class="grit-sheet-handle"></div>
      <div class="text-[17px] font-bold text-ink mb-3">Completed goals</div>
      ${rows}
      <button id="cg-close" class="w-full text-inksoft font-bold py-3 mt-2">Close</button>
    </div>`;
  overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
  overlay.querySelector('#cg-close').onclick = close;
  document.body.appendChild(overlay);
}
